module.exports = __webpack_public_path__ + "media/images/bg-ca1f45c8dbed196e025885880ccedb2a.jpg";